<template>
  <div class="container content-block pt-3 pb-3" v-if="isSimpleMode">
    <div class="title article-title">
      <h2 class="title">Opdrachtomschrijving</h2>
    </div>
    <div class="row explanation mt-3">
      <div class="col">
        <p>
          Beweeg tussendoortjes zijn eenvoudige oefeningen die je in de dagdagelijkse werking van je klas kan gebruiken
          om lange periodes van stilzitten te onderbreken en de concentratie opnieuw aan te scherpen. Gemiddeld nemen ze
          2 tot 5 minuten in beslag. Je kiest als leerkracht zelf het meest geschikte moment voor een
          bewegingstussendoortje. Je kan de bewegingstussendoortjes in de klas uitvoeren, maar ook in andere ruimtes
          zoals de gang of de trappenhal. De werkvorm bouwt verder op de algemene visie van ‘bewegingstussendoortjes op
          school’. Wanneer je dit inplant zal een willekeurige opdracht verschijnen die je met de klas kan uitvoeren om
          zo één batterijtje te verdienen voor jullie beweegbuddy.
        </p>
      </div>
    </div>
  </div>
  <div class="container content-block pt-3 pb-3" v-else>
    <div class="title article-title">
      <h2 class="title">Opdrachtomschrijving</h2>
    </div>
    <div class="row image mt-3" v-if="quest.mediaItem && quest.mediaItem.type !== mediaItemTypeEnum.none">
      <div class="col">
        <div class="activity-image"
             v-if="quest.mediaItem.type === mediaItemTypeEnum.image && quest.mediaItem.imageAsset">
          <img class="img-fluid" :src="quest.mediaItem.imageAsset.url" alt="Activiteit afbeelding"/>
        </div>
        <div class="embed-responsive embed-responsive-16by9 activity-video"
             v-if="quest.mediaItem.type === mediaItemTypeEnum.video && quest.mediaItem.videoUrl">
          <iframe class="embed-responsive-item" :src="convertYoutubeUrlToEmbedUrl(quest.mediaItem.videoUrl)"
                  title="YouTube video player"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen></iframe>
        </div>
      </div>
    </div>

    <!--Description-->
    <template v-if="quest.type === questTypeEnum.impulse">
      <div class="row explanation mt-3" v-if="quest.descriptionTeacher">
        <div class="col">
          <h3>Beschrijving</h3>
          <p class="quest-description">{{ quest.descriptionTeacher }}</p>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="row explanation mt-3" v-if="quest.descriptionTeacher">
        <div class="col">
          <h3>Beschrijving voor de leerkracht</h3>
          <p class="quest-description">{{ quest.descriptionTeacher }}</p>
        </div>
      </div>
      <div class="row explanation mt-3" v-if="quest.descriptionStudent">
        <div class="col">
          <h3>Beschrijving voor de leerlingen</h3>
          <p class="quest-description">{{ quest.descriptionStudent }}</p>
        </div>
      </div>
    </template>

    <div class="row results" v-if="quest.questResults?.length > 0">
      <div class="col">
        <h3>Resultaten</h3>
        <div v-for="(result, index) in quest.questResults" :key="index">
          <label>{{ result.label }} (<span class="type">{{ questResultTypeToString(result.format) }}</span>)</label>
        </div>
      </div>
    </div>
    <div class="row quiz-questions mt-3" v-if="quest.format === questFormatEnum.quiz">
      <div class="col">
        <QuestQuizDetails :questions="quest.quizQuestions"></QuestQuizDetails>
      </div>
    </div>
    <div class="row quest-puzzle mt-3" v-if="quest.format === questFormatEnum.puzzle">
      <div class="col">
        <QuestPuzzleDetails :puzzle="quest.puzzle" :quest-type="quest.type"></QuestPuzzleDetails>
      </div>
    </div>
    <div class="row documents" v-if="quest.questDocuments?.length > 0">
      <div class="col">
        <h3>Documenten</h3>
        <div class="document-container">
          <Document v-for="document in quest.questDocuments" :key="document.id" :document="document"></Document>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Document from "@/components/Document";
import QuestQuizDetails from "@/components/Quests/QuestQuizDetails";
import QuestPuzzleDetails from "@/components/Quests/QuestPuzzleDetails";
import { QuestMediaTypeEnum, QuestFormatEnum, QuestTypeEnum } from "sandpiper_api";
import QuestResultsHelper from "@/mixins/QuestResultsHelper";
import YoutubeVideoEmbedder from "@/mixins/YoutubeVideoEmbedder";
//import SoundPlayer from "@/utils/SoundPlayer";
//import {Sound} from "@/enums/Sound";

export default {
  name: "QuestDetailPanel",
  components: { QuestQuizDetails, QuestPuzzleDetails, Document },
  mixins: [ QuestResultsHelper, YoutubeVideoEmbedder ],
  props: {
    quest: Object
  },
  data()
  {
    return {
      mediaItemTypeEnum: new QuestMediaTypeEnum(),
      questFormatEnum: new QuestFormatEnum(),
      questTypeEnum: new QuestTypeEnum()
    }
  },
  computed: {
    isSimpleMode()
    {
      // return this.quest.type === this.questTypeEnum.impulse;
      return false;
    }
  },
  mounted() {
    //SoundPlayer.playMusic(Sound.BABAYETU);
  }
}
</script>

<style lang="scss" scoped>
.article-title
{
  padding-bottom: 1rem;
}

.image img
{
  border-radius: 5px;
}

.document-container
{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
  grid-auto-rows: 50px;

  grid-gap: 10px 25px;
}

.quest-description
{
  white-space: pre-line;
}
</style>